import AccountBusinessSearch from '@/pages/accountBusinessManage/accountBusinessSearch'

export default [
  {
    path: '/accountBusinessSearch',
    name: 'AccountBusinessSearch',
    component: AccountBusinessSearch,
    meta: { name: '代理账户查询' }
  }
]



// WEBPACK FOOTER //
// ./src/router/accountBusinessManage/accountBusinessSearch.js